import { type Store, createStore, sample } from 'effector';
import { isEqual } from 'lodash';

export const createTunnel = <T, K>($sourceStore: Store<K>, query: (store: K) => T) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const $store = createStore<T>(null as any);
    sample({
        source: $sourceStore.map(query),
        filter: (value) => !isEqual(value, $store.getState()),
        target: $store,
    });
    return $store;
};
